import * as React from 'react';

// SVG plano (no createIcon) para conservar el `fill="none"` del root: las formas
// con solo `stroke` se rellenarían de currentColor con createIcon.
type IconProps = React.SVGProps<SVGSVGElement>;

export function VentasIcon(props: IconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 34 34'
      fill='none'
      width={24}
      height={24}
      {...props}>
      <rect x='5' y='15' width='24' height='16' rx='3' fill='#0E3663' />
      <rect x='8' y='18' width='12' height='10' rx='2' fill='#5CC9BA' />
      <path
        d='M10 24L12.5 21.5L14.5 23L18 19.5'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M6 5H28L31 13H3L6 5Z' fill='#3885FE' />
      <rect x='3' y='12' width='7' height='4.5' rx='2.2' fill='#F55266' />
      <rect x='10' y='12' width='7' height='4.5' rx='2.2' fill='white' />
      <rect x='17' y='12' width='7' height='4.5' rx='2.2' fill='#F55266' />
      <rect x='24' y='12' width='7' height='4.5' rx='2.2' fill='white' />
      <rect x='21' y='18' width='5' height='13' rx='1.5' fill='#1E4D8C' />
      <circle cx='25.5' cy='25.5' r='6' fill='#FFB800' />
      <circle cx='25.5' cy='25.5' r='4.3' fill='#FFD25C' />
      <path
        d='M25.5 22V29M23.5 24C23.5 23.2 24.2 22.8 25.5 22.8C26.8 22.8 27.5 23.4 27.5 24C27.5 25.2 23.5 25.5 23.5 27C23.5 27.8 24.2 28.2 25.5 28.2C26.8 28.2 27.5 27.6 27.5 27'
        stroke='#0E3663'
        strokeWidth='1.6'
        strokeLinecap='round'
      />
    </svg>
  );
}
